import { FC } from 'react'

import Arrow from '@/images/arrow-back.svg'

import './ExchangeButton.scss'


interface ExchangeButtonProps {
    onClick: () => void
    text: string
}

export const ExchangeButton: FC<ExchangeButtonProps> = ({ onClick, text }) => (
    <button onClick={onClick} type="button" className="exchange-button">
        {text}
        <div className="exchange-button__arrow">
            <img alt="arrow-back" src={Arrow} />
        </div>
    </button>
)
